export default "__VITE_ASSET__CwCtSaY2__"